import { ErrorMessage, Field, Form, Formik } from "formik";
import { Modal } from "react-bootstrap";
import { ICountry, initialFormData } from "..";
import axiosClient from "../../../../../utils/api/axiosClient";
import { getToken } from "../../../../../utils/functions";
import { CountrySchema } from "../validation";

export default function FormModel(props: any) {
  const { setCountries, setInitial, modalShow, setModalShow } = props;
  const initial = props.initial as ICountry;

  const handleSubmit = (values: ICountry) => {
    const headers = { Authorization: getToken() };
    const payload = {
      name: values.name,
      code: values.code,
      isdCode: values.isdCode,
      status: values.status,
    };
    if (initial.id) {
      axiosClient
        .put("v1/countries/" + initial.id, payload, { headers })
        .then((res) => {
          if (res.status === 200) setCountries(res.data);
        });
    } else {
      axiosClient
        .post("v1/countries", payload, { headers })
        .then((res) => {
          if (res.status === 200) setCountries(res.data);
        });
    }
    values.name = "";
    values.code = "";
    values.isdCode = "";
    values.status = false;
    setInitial(initialFormData);
  };

  return (
    <Modal
      show={modalShow}
      onHide={() => setModalShow(false)}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Edit Country
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Formik
          initialValues={initial}
          validationSchema={CountrySchema}
          onSubmit={handleSubmit}
        >
          {({ touched, errors, isSubmitting, values }) => (
            <Form className="auth-form login-form">
              <div className="email mb-3">
                <label htmlFor="name">Country Name</label>
                <Field
                  id="name"
                  name="name"
                  values={initial.name}
                  placeholder="Enter Name"
                  autoComplete="off"
                  className={`mt-2 form-control ${
                    touched.name && errors.name ? "is-invalid" : ""
                  }`}
                />

                <ErrorMessage
                  component="div"
                  name="name"
                  className="invalid-feedback"
                />
              </div>
              <div className="code mb-3">
                <label htmlFor="code">Country Code</label>
                <Field
                  id="code"
                  name="code"
                  values={initial.code}
                  placeholder="Enter Country Code"
                  autoComplete="off"
                  className={`mt-2 form-control ${
                    touched.code && errors.code ? "is-invalid" : ""
                  }`}
                />

                <ErrorMessage
                  component="div"
                  name="code"
                  className="invalid-feedback"
                />
              </div>
              <div className="isdCode mb-3">
                <label htmlFor="isdCode">Isc Code</label>
                <Field
                  id="isdCode"
                  name="isdCode"
                  values={initial.isdCode}
                  placeholder="Enter Name"
                  autoComplete="off"
                  className={`mt-2 form-control ${
                    touched.isdCode && errors.isdCode ? "is-invalid" : ""
                  }`}
                />

                <ErrorMessage
                  component="div"
                  name="isdCode"
                  className="invalid-feedback"
                />
              </div>
              <div className="extra mt-3 row justify-content-between">
                <div className="col-6">
                  <div className="form-check">
                    <label className="form-check-label" htmlFor="status">
                      Is active ?
                    </label>
                    <input
                      id="status"
                      name="status"
                      className="form-check-input"
                      type="checkbox"
                      defaultValue=""
                    />
                  </div>
                </div>
              </div>
              <div className="text-center">
                <button
                  type="submit"
                  className="btn app-btn-primary w-100 theme-btn mx-auto"
                >
                  SAVE
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  );
}
